module.exports = __webpack_public_path__ + "static/media/check_icon.d74a0ad8.svg";